// extracted by mini-css-extract-plugin
module.exports = {"wrap":"zf","heading":"Af"};